import { NutsTypeEnum } from "./enums/nutstype.enum";

export class CustomerContract {
    ean: string;
    installationType: NutsTypeEnum;
    streetName: string | undefined;
    houseNumber: string | undefined;
    location: string | undefined;
    postalCode: string | undefined;
    country: string | undefined;
    constructor(ean: string, installationType: NutsTypeEnum, streetName?: string, houseNumber?: string, location?: string, postalCode?: string, country?: string) {
        this.ean = ean;
        this.installationType = installationType;
        this.streetName = streetName;
        this.houseNumber = houseNumber;
        this.location = location;
        this.postalCode = postalCode;
        this.country = country;
    }
    static jsonToCustomerContract(json: any): CustomerContract {
        return new CustomerContract(json.ean, json.installationType, json.streetName, json.houseNumber, json.location, json.postalCode, json.country);
    }
}